import entityReducer from "./dealEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
